"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const onchainAccountPoolToken_1 = __importDefault(require("./onchainAccountPoolToken"));
class OnchainAccountLendingVault extends onchainAccountPoolToken_1.default {
    constructor(account, lendingVault) {
        super();
        this.lendingVaultCache = {};
        this.getVaultAddress = () => this.poolToken.getVaultAddress();
        this.getAccount = () => this.account;
        this.getInteractionsLendingVault = this.getInteractionsPoolToken;
        this.getOffchainAccountLendingVault = this.getOffchainAccountPoolToken;
        this.account = account;
        this.poolToken = lendingVault;
    }
    getInteractionsPoolToken() {
        return this.account.getInteractions().getLendingVault(this.getVaultAddress());
    }
    getOffchainAccountPoolToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.account.getOffchainAccount().getLendingVault(this.getVaultAddress());
        });
    }
    cleanCache() {
        this.cache = {};
        this.lendingVaultCache = {};
    }
    // OnchainInteractions
    getMaxWithdrawable() {
        return __awaiter(this, void 0, void 0, function* () {
            const deposited = (yield this.getDeposited()) * this.getDust();
            const availableCash = (yield this.poolToken.getAvailableLiquidity()) * (1 - this.getLiquidityBuffer());
            return Math.min(deposited, availableCash);
        });
    }
}
exports.default = OnchainAccountLendingVault;
